import PropTypes from 'prop-types';
import React from 'react';

import { useFormContext } from 'react-hook-form';

import InputFieldText from 'components/form/inputFields/InputFieldText/InputFieldText';

const ContentElementMAAcquiredName = ({ index = 0 }) => {
  const name = 'companyAcquiredName';
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <InputFieldText
      id={`${name}${index}`}
      {...register(name, {
        required: {
          value: true,
          message: 'Please provide the name of the acquired company',
        },
      })}
      testId="company-content-m&a-inputCompanyAcquiredName"
      errors={errors}
      placeholder="Type the name of the acquired company..."
    >
      <InputFieldText.Label>Name of the acquired company*</InputFieldText.Label>
    </InputFieldText>
  );
};

ContentElementMAAcquiredName.propTypes = {
  index: PropTypes.number,
};

export default ContentElementMAAcquiredName;
